import antd, { Form, Collapse, Row, Col, PageHeader } from 'antd';
import styled from 'styled-components';
import ScreenHelper from '../../Styled/ScreenHelper';
import { ColSize } from 'antd/lib/col';

export const PaymentText = styled.h1`
  font-size: 2em;
`;
